import loadjs from "loadjs"
import { useEffect } from "react"

import Image from "components/ui/image"
import { IS_US, IS_CA, IS_UK } from "helpers/application"

const HolidayGiftFinderQuiz = () => {
  useEffect(() => {
    const loadQuiz = () => {
      window.DIGIOH_API.LIGHTBOX.loadLightbox(
        IS_US()
          ? "2d213621-2ce6-439d-b782-66663d0ca760" // US 315150
          : IS_CA()
            ? "c971db6e-55b7-49d2-93e8-0641c20a6d1b" // CA 317072
            : IS_UK()
              ? "a05f4780-e69d-4564-9ffa-1ef4bc69efa9" // UK 317075
              : "89f6bbd4-4ac3-485f-801b-fbfcb81c4001" // AU 317076
      )
    }

    if (window.DIGIOH_API && window.DIGIOH_API.LIGHTBOX) {
      loadQuiz()
    } else {
      loadjs(
        [
          `https://www.lightboxcdn.com/vendor/7c3a4ec6-f10d-4926-b14d-64ee5d0a9611/lightbox_speed.js?mb=${new Date().getTime()}`,
        ],
        { async: true, returnPromise: true }
      )
        .then(() => loadQuiz())
        .catch((err) => console.log(`Error loading quiz: ${err}`))
    }
  }, [])

  return (
    <div
      className="[&>*:nth-child(n+2)]:hidden"
      id="gift-finder-quiz"
      style={{ minHeight: "560px" }}
    >
      <div className="my-48 text-center" style={{ minHeight: "350px" }}>
        <Image
          alt="Loading"
          height="175"
          lazyload={false}
          src={require("images/layout/loadinglarge.gif")}
          width="175"
        />
      </div>
    </div>
  )
}

export default HolidayGiftFinderQuiz
